import { OrderProgressEntity } from 'orders/domain/entities/order.entity'
import { formatDate, formatHour } from 'utils/formatting'

const STATE_LABELS: Record<string, string> = {
    IN_PROCESS: 'En proceso',
    FINISHED: 'Finalizado',
    PENDING: 'Pendiente',
    CANCELED: 'Cancelado',
    FAILED: 'Fallido',
}

function getElapsedTime(createdAt: string): string {
    const start = new Date(createdAt)
    const now = new Date()
    const diffMs = now.getTime() - start.getTime()
    if (diffMs < 0) return '—'
    const totalMinutes = Math.floor(diffMs / 60000)
    const hours = Math.floor(totalMinutes / 60)
    const minutes = totalMinutes % 60
    return `${String(hours).padStart(2, '0')} hs ${minutes} m`
}

interface Props {
    progress: OrderProgressEntity
    onViewTemplate?: () => void
}

export default function SorterOrderOverview({ progress, onViewTemplate }: Props) {
    const stateLabel = STATE_LABELS[progress.state] ?? progress.state
    const elapsed = progress.state === 'IN_PROCESS' ? getElapsedTime(progress.createdAt) : undefined

    return (
        <div className="bg-white border border-[#E2E8F0] rounded-xl flex divide-x divide-[#E2E8F0] min-h-[93px]">
            <div className="flex flex-col px-4 py-4 flex-1 min-w-0 justify-center gap-1">
                <span className="text-sm text-[#475569]">Creada el</span>
                <div className="flex flex-col gap-[2px]">
                    <span className="text-base font-semibold text-[#070A13]">{formatDate(progress.createdAt)}</span>
                    <span className="text-xs text-[#475569]">{formatHour(progress.createdAt)} hs</span>
                </div>
            </div>

            <div className="flex flex-col px-4 py-4 flex-1 min-w-0 justify-between">
                <span className="text-sm text-[#475569]">Plantilla</span>
                <div className="flex flex-col gap-[2px]">
                    <span className="text-base font-medium text-[#070A13] truncate" title={progress.templateName ?? undefined}>{progress.templateName ?? '—'}</span>
                    {onViewTemplate && (
                        <button
                            type="button"
                            onClick={onViewTemplate}
                            className="text-xs text-[#568C13] hover:underline w-fit text-left leading-[1.2]"
                        >
                            Ver detalles
                        </button>
                    )}
                </div>
            </div>

            <div className="flex flex-col px-4 py-4 flex-1 min-w-0 justify-center gap-1">
                <span className="text-sm text-[#475569]">Estado</span>
                <div className="flex flex-col gap-[2px]">
                    <span className="text-base font-semibold text-[#070A13]">{stateLabel}</span>
                    {elapsed && (
                        <span className="text-xs text-[#475569]">Tiempo: {elapsed}</span>
                    )}
                </div>
            </div>

            <div className="flex flex-col px-4 py-4 flex-1 min-w-0 justify-center">
                <span className="text-sm text-[#475569]">Avance</span>
                <div className="flex flex-col gap-[2px]">
                    <span className="text-base font-medium text-[#070A13]">{progress.totalProcessed}</span>
                    <span className="text-xs text-[#475569]">Procesados</span>
                </div>
            </div>
        </div>
    )
}
